<div class="flex-container">
  <input [id]="inputId"
         [name]="name"
         [type]="visible ? 'text' : 'password'"
         [autocomplete]="autocomplete"
         [placeholder]="placeholder"
         [disabled]="isDisabled"
         [value]="value"
         (input)="onInput($event)"
         (blur)="onTouched()"
         class="form-control">
  <button type="button"
          class="hide-show-pwd-icon"
          [title]="visible ? hideTitle : showTitle"
          [attr.aria-label]="visible ? hideTitle : showTitle"
          (click)="visible = !visible"
          tabindex="-1">
    <span class="e-icon icon-password-visibilty"
          [class.icon-view--filled]="!visible"
          [class.icon-view--off--filled]="visible">
    </span>
  </button>
</div>
